import React, { Suspense } from "react";
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";

import Loading from "./components/Loading";
import ScrollToTopOnMount from "./helpers/ScrollToTopOnMount";
import HandleBack from "./helpers/HandleBack";

import ProtectedRoute from "./protectedRoute/ProtectedRoute";
import TaskContextProvider from "./context/TaskContext";

const Login = React.lazy(() => import('./pages/Login'))
const Home = React.lazy(() => import('./pages/Dashboard/Home'))
const Page404 = React.lazy(() => import('./pages/Error/Page404'))
const Page503 = React.lazy(() => import('./pages/Error/Page503'))
// const EditProfile = React.lazy(() => import('./pages/Dashboard/EditProfile'))
const Tasks = React.lazy(() => import('./pages/Dashboard/Tasks'))
const TasksMap = React.lazy(() => import('./pages/Dashboard/TasksMap'))
const SingleTask = React.lazy(() => import('./pages/Dashboard/SingleTask'))

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter basename="/espace-client/">
        <ScrollToTopOnMount />
        <HandleBack />
        <Switch>
          <Route exact path="/" component={Login} />
          <Route path="/page-404" component={Page404} />
          <Route path="/page-503" component={Page503} />
          <ProtectedRoute path="/account" Component={Home} />
          <TaskContextProvider>
            <ProtectedRoute path="/tasks" Component={Tasks} />
            <ProtectedRoute path="/single-task/:slug" Component={SingleTask} />
            <ProtectedRoute path="/tasks-map" Component={TasksMap} />
          </TaskContextProvider>
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
